import React from "react";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { SportSelectionCard } from "@/features/betslip/components/cards/SportSelectionCard";
import { RaceSelectionCard } from "@/features/betslip/components/cards/RaceSelectionCard";
import { SemSelectionCard } from "@/features/betslip/components/cards/SemSelectionCard";
import { ExoticSelectionCard } from "@/features/betslip/components/cards/ExoticSelectionCard";
import { QuaddieSelectionCard } from "@/features/betslip/components/cards/QuaddieSelectionCard";

type SelectionProps = {
  outcomeId: string;
};

export const Selection = React.memo(({ outcomeId }: SelectionProps) => {
  const selection = useBetslipStore((s) => s.selections[outcomeId]);
  if (!selection) return null;

  switch (selection.kind) {
    case "match":
    case "outright":
      return <SportSelectionCard outcomeId={outcomeId} selection={selection} />;
    case "race":
      return <RaceSelectionCard outcomeId={outcomeId} selection={selection} />;
    case "sem":
      return <SemSelectionCard outcomeId={outcomeId} selection={selection} />;
    case "exotic":
      return (
        <ExoticSelectionCard outcomeId={outcomeId} selection={selection} />
      );
    case "quaddie":
      return (
        <QuaddieSelectionCard outcomeId={outcomeId} selection={selection} />
      );
  }
});

Selection.displayName = "Selection";
